import classNames from 'classnames';
import combineModifiers from '../../../../../utils/modifiers/combineModifiers';

export default function Image({ className, img, extraIcon, modifier }) {
  return (
    (img || extraIcon) && (
      <div
        className={classNames(
          'universal-modal__image',
          className,
          ...combineModifiers('universal-modal__image', modifier),
        )}
      >
        {img && <img src={img} className={'universal-modal__image-img'} />}

        {extraIcon && (
          <div className={'universal-modal__image-extra-icon'}>
            <img src={extraIcon} className={'universal-modal__image-extra-icon-image'} />
          </div>
        )}
      </div>
    )
  );
}
